import {
  IItem,
} from "../items";
import { AbstractDocumentItemAlert } from "./AbstractDocumentItemAlert";

export abstract class AbstractEmptyAlert<T extends IItem> extends AbstractDocumentItemAlert<T> {
  constructor(itemSetId: number, item: T, isError: boolean = true) {
    super(itemSetId, item, isError);
  }

  get target(): string {
    return "「"
      + this.itemName
      + "」";
  }

  protected abstract get itemName(): string;

  get description(): string {
    // 確認ダイアログでキャンセル押したタイミングでisErrorがtrueになるので微妙ではある
    return this.isError
      ? "入力されていないため、登録できません。"
      : "入力されていません。";
  }
}
